import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody,
  Button, Text, Flex, Alert, AlertIcon,
} from '@chakra-ui/react';
import * as FiIcons from 'react-icons/fi';
import { deleteServer } from '../../../../../store/servers/serversSlice';
import theme from '../../../../global/theme';

const DeleteModal = ({ data, onClose }) => {
  const dispatch = useDispatch();
  const servers = useSelector(state => state.servers);

  return (
    <Modal isOpen onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent borderRadius={4} paddingBlock={4} bg={theme.dark}>
        <ModalHeader textAlign="center" color="red.400" fontSize={20}>
          حذف السيرفر
        </ModalHeader>
        <ModalBody>
          {servers.errors.length > 0 && (
            <Alert status="error" variant="left-accent" marginBottom={4}>
              <AlertIcon />
              {servers.errors.map((e, i) => <Text key={i}>{e?.msg}</Text>)}
            </Alert>
          )}
          <Text color={theme.light} textAlign="center">
            هل أنت متأكد من حذف السيرفر <strong>{data.name}</strong>؟
          </Text>
        </ModalBody>
        <ModalFooter>
          <Flex justifyContent="center" gap={3} width="100%">
            <Button rightIcon={<FiIcons.FiTrash2 />} colorScheme="red"
              isLoading={servers.isLoading}
              onClick={() => dispatch(deleteServer(data)).unwrap().then(() => onClose())}>
              حذف
            </Button>
            <Button rightIcon={<FiIcons.FiX />} colorScheme="gray"
              isLoading={servers.isLoading} onClick={onClose}>
              إلغاء
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteModal;
